import React from 'react';
import {
  Box,
  Checkbox,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { SaktiFaceRegistryFilters, InspeksiEstateOption, InspeksiDivisionOption } from '../types';

interface Props {
  filters: SaktiFaceRegistryFilters;
  estates: InspeksiEstateOption[];
  divisions: InspeksiDivisionOption[]; // pre-filtered by hook based on selected estate
  jobPositions: string[];
  onSearchChange: (v: string) => void;
  onEstateOdooIdChange: (id: number | undefined) => void;
  onDivisionOdooIdChange: (id: number | undefined) => void;
  onJobPositionChange: (v: string | undefined) => void;
  onEnrolledOnlyChange: (v: boolean) => void;
}

const SaktiFaceRegistryFilterBar: React.FC<Props> = ({
  filters,
  estates,
  divisions,
  jobPositions,
  onSearchChange,
  onEstateOdooIdChange,
  onDivisionOdooIdChange,
  onJobPositionChange,
  onEnrolledOnlyChange,
}) => {

  return (
    <Box bg="white" borderRadius="lg" p={4} borderWidth="1px" borderColor="gray.200">
      <VStack align="stretch" spacing={3}>
        <HStack spacing={3} flexWrap="wrap">
          <InputGroup maxW="320px" minW="200px">
            <InputLeftElement pointerEvents="none">
              <Box as={FiSearch} color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Cari nama / NIP..."
              value={filters.search}
              onChange={(e) => onSearchChange(e.target.value)}
              bg="gray.50"
              borderColor="gray.200"
              _focus={{ borderColor: 'customGreen.400', bg: 'white' }}
            />
          </InputGroup>

          <Select
            maxW="200px"
            minW="160px"
            placeholder="Semua Estate"
            value={filters.estateOdooId ?? ''}
            onChange={(e) =>
              onEstateOdooIdChange(e.target.value ? Number(e.target.value) : undefined)
            }
            bg="gray.50"
            borderColor="gray.200"
            _focus={{ borderColor: 'customGreen.400' }}
          >
            {estates.map((est) => (
              <option key={est.id} value={est.odoo_id}>
                {est.name}
              </option>
            ))}
          </Select>

          <Select
            maxW="200px"
            minW="160px"
            placeholder="Semua Divisi"
            value={filters.divisionOdooId ?? ''}
            onChange={(e) =>
              onDivisionOdooIdChange(e.target.value ? Number(e.target.value) : undefined)
            }
            isDisabled={divisions.length === 0}
            bg="gray.50"
            borderColor="gray.200"
            _focus={{ borderColor: 'customGreen.400' }}
          >
            {divisions.map((div) => (
              <option key={div.id} value={div.odoo_id}>
                {div.name}
              </option>
            ))}
          </Select>

          <Select
            maxW="200px"
            minW="160px"
            placeholder="Semua Jabatan"
            value={filters.jobPosition ?? ''}
            onChange={(e) =>
              onJobPositionChange(e.target.value || undefined)
            }
            bg="gray.50"
            borderColor="gray.200"
            _focus={{ borderColor: 'customGreen.400' }}
          >
            {jobPositions.map((job) => (
              <option key={job} value={job}>
                {job}
              </option>
            ))}
          </Select>

          <Checkbox
            isChecked={filters.enrolledOnly}
            onChange={(e) => onEnrolledOnlyChange(e.target.checked)}
            colorScheme="green"
          >
            <Text fontSize="sm" fontWeight="medium">
              Sudah terdaftar saja
            </Text>
          </Checkbox>
        </HStack>
      </VStack>
    </Box>
  );
};

export default SaktiFaceRegistryFilterBar;
